import test0No from './answers/no/answers-test0.json';
import test3No from './answers/no/answers-test3.json';
import test4No from './answers/no/answers-test4.json';
import test5No from './answers/no/answers-test5.json';
import test6No from './answers/no/answers-test6.json';
import testBH6No from './answers/no/answers-test6-BH.json';
import test7No from './answers/no/answers-test7.json';
import testBH7No from './answers/no/answers-test7-BH.json';
import test8No from './answers/no/answers-test8.json';
import test9No from './answers/no/answers-test9.json';

import test0Nn from './answers/nn/answers-test0.json';
import test3Nn from './answers/nn/answers-test3.json';
import test4Nn from './answers/nn/answers-test4.json';
import test5Nn from './answers/nn/answers-test5.json';
import test6Nn from './answers/nn/answers-test6.json';
import testBH6Nn from './answers/nn/answers-test6-BH.json';
import test7Nn from './answers/nn/answers-test7.json';
import testBH7Nn from './answers/nn/answers-test7-BH.json';
import test8Nn from './answers/nn/answers-test8.json';
import test9Nn from './answers/nn/answers-test9.json';

export const no = {
	test0: test0No,
	test3: test3No,
	test4: test4No,
	test5: test5No,
	test6: test6No,
	testBH6: testBH6No,
	test7: test7No,
	testBH7: testBH7No,
	test8: test8No,
	test9: test9No,
};

export const nn = {
	test0: test0Nn,
	test3: test3Nn,
	test4: test4Nn,
	test5: test5Nn,
	test6: test6Nn,
	testBH6: testBH6Nn,
	test7: test7Nn,
	testBH7: testBH7Nn,
	test8: test8Nn,
	test9: test9Nn,
};

export const nonword_child_trialWords = [
	// practice item(s) – you can tweak text to match exactly the recording
	'Kap',
];

export const nonword_child_testWords = [
	'Kjæf', // 1  (long vowel)
	'Blyng', // 2
	'Nælle', // 3
	'Tikle', // 4
	'Skjaile', // 5
	'Gråmøl', // 6
	'Finglar', // 7
	'Kjipler', // 8
	'Øplin', // 9
	'Brångsel', // 10
	'Trumplese', // 11
	'Kjaflende', // 12
	'Ufibberang', // 13
	'Skjenglefunt', // 14
	'Kjimplerank', // 15
	'Flångsteront', // 16
];

// Non-word repetition – youth followup (NO)
export const nonword_youth_trialWords = [
	// practice item
	'Frast',
];

export const nonword_youth_testWords = [
	// 1–16 in the same order as the Y audio files
	'Sprølt', // 1
	'Kvolp', // 2
	'Blømsk', // 3
	'Trompelten', // 4
	'Skjålving', // 5
	'Fløymsker', // 6
	'Drøvlesker', // 7
	'Klympensk', // 8
	'Strævlinger', // 9
	'Øflotterong', // 10
	'Kjasternest', // 11
	'Brångelsvikt', // 12
	'Grømslefosking', // 13
	'Snømpleruster', // 14
	'Flangsterinter', // 15
	'Nevrinatalske', // 16
];

export const nonword_adult_trialWords = ['Skjofenal'];

export const nonword_adult_testWords = [
	'Kjolter', // 1
	'Knaistre', // 2
	'Ublømst', // 3
	'Sumpeltansk', // 4
	'Pinketargen', // 5
	'Skjohanger', // 6
	'Nangotisme', // 7
	'Klimpenansk', // 8
	'Stratinskere', // 9
	'Uklarterende', // 10
	'Åbbedører', // 11
	'Ugrimelingst', // 12
	'Ulterabras', // 13
	'Pleikeraude', // 14
	'Spranteriadene', // 15
	'Nutrotisisme', // 16
];
